import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ClientLogos from "./components/ClientLogos";
import MarqueeBands from "./components/MarqueeBands";
import Statement from "./components/Statement";
import Testimonials from "./components/Testimonials";
import RecentWorks from "./components/RecentWorks";
import Services from "./components/Services";
import Founder from "./components/Founder";
import Awards from "./components/Awards";
import Pricing from "./components/Pricing";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const Landing = () => {
  return (
    <div className="bg-[#ececec]">
      <Navbar />
      <Hero />
      <ClientLogos />
      <MarqueeBands />
      <Statement />
      <Testimonials />
      <RecentWorks />
      <Services />
      <Founder />
      <Awards />
      <Pricing />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
